module.exports = __webpack_public_path__ + "img/down-square.2fd6ae8d.svg";